import type { AlpineComponent } from 'alpinejs';
import { Cookies } from '../utils/cookies';

export const cartCounters: AlpineComponent = {
	cartCount: 0,
	quoteCount: 0,
	endpoint: '',

	initialize(cartCount: number, quoteCount: number, url: string) {
		this.cartCount = cartCount ?? 0;
		this.quoteCount = quoteCount ?? 0;
		const formKey = Cookies.get('form_key');
		this.endpoint = `${url}?form_key=${formKey}`;
	},

	async update() {
		const { cartCounter, quoteCounter } = await (
			await fetch(this.endpoint)
		).json();
		this.cartCount = cartCounter ?? this.cartCount;
		this.quoteCount = quoteCounter ?? this.quoteCount;
	}
};
